import React from 'react';

import {
  CIBO_LOCATION_ADJUSTMENT_PERIOD_IN_HOURS,
  CIBO_LOCATION_ADJUSTMENT_PERIOD_OVERRIDE_ROLES
} from 'constants/integrations';
import { INTERNAL_ADMIN_ROLE_TO_LABEL } from 'constants/internal-admin-roles';
import { useMyUserIsInternalAdmin } from 'store/modules/myUser/hooks';

const ciboOverrideRolesLabel = CIBO_LOCATION_ADJUSTMENT_PERIOD_OVERRIDE_ROLES
  .map((role) => INTERNAL_ADMIN_ROLE_TO_LABEL[role])
  .join(', ');

export const InternalAdminMessage = {
  CIBO_LOCATION_MOVABILITY:
    `Note: The ${CIBO_LOCATION_ADJUSTMENT_PERIOD_IN_HOURS} hour limit doesn’t apply to ${ciboOverrideRolesLabel}.`,
  SUBSCRIBE_TO_ALERTS: 'Note: Only enterprise members can subscribe to alerts.',
  SUBSCRIBE_TO_REPORTS: 'Note: Only enterprise members can subscribe to reports.'
} as const;

type InternalAdminMessageValue = typeof InternalAdminMessage[keyof typeof InternalAdminMessage];

/**
 * Includes a leading whitespace to allow seamless concatenation with other elements
 */
export default function InternalAdminNote({ message }: { message: InternalAdminMessageValue }) {
  const isInternalAdmin = useMyUserIsInternalAdmin();
  if (!isInternalAdmin) return null;
  return (
    <>{' '}<span className="internal-admin">{message}</span></>
  );
}